import React from "react";
import { Button } from "@material-ui/core/";

function ButtonUi(props) {
  const handleClick = () => {
    if (props.onClick) {
      props.onClick();
    }
  };
  return (
    <Button
      type="submit"
      fullWidth
      variant="contained"
      onClick={handleClick}
      color="primary"
    >
      {props.children}
    </Button>
  );
}

export default ButtonUi;
